/**
 * @todo автокомплит открывается при инициализации
 */
export default {
  name: "Input",
  props: ["name", "value", "list", "required", "regex", "message", "checkbox", "regex", "readonly", "autocomplete","centered"],

  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      isValid: true,
      internalValue: "",
      internalMessage: "",
      showContainer: false,
      autoComplete: [],
    }
  },
  beforeMount() {
    this.internalValue = this.value
    this.internalMessage = this.message
    if (!this.message && this.required) {
      this.internalMessage = "поле обязательно для заполнения"
    }
  },
  mounted() {},
  watch: {
    value: function (newValue) {
      this.internalValue = newValue
    },
    internalValue: function (newValue) {
      if (this.autocomplete) {
        if (!this.list.includes(newValue)) {
          this.autocomplete(newValue)
        }
      }
    },
    list: function (value) {
      if (this.autocomplete && value.length) {
        this.showContainer = true
      }
    },
  },
  methods: {
    changeOption(option) {
      if (!this.autocomplete) {
        this.internalValue = option
      } else {
        this.internalValue = this.list[option]
      }
      this.showContainer = false
      this.validate();
      this.$emit("update:value", this.internalValue)
    },
    validate() {
      this.$emit("update:value", this.internalValue)
      this.isValid = !(this.required && !this.internalValue)
      if (this.regex && this.internalValue) {
        let regex = new RegExp(this.regex)
        this.isValid = regex.test(this.internalValue)
        console.log("regex", regex.test(this.internalValue))
      }
      this.$forceUpdate()
    },
    check(value) {
      if (typeof this.internalValue !== typeof []) {
        if (this.internalValue === this.checkbox) {
          this.internalValue = ""
        } else {
          this.internalValue = this.checkbox
        }
      } else {
        if (this.internalValue.includes(value)) {
          this.internalValue.splice(this.internalValue.indexOf(value), 1)
        } else {
          this.internalValue.push(value)
        }
      }
      this.$emit("update:value", this.internalValue)
    },

    close() {
      this.showContainer = false
    },
  },
  template:
    '<div v-if="!checkbox" class="minput minput__stacked"><label @click="showContainer = !showContainer" v-bind:class="{ \'has-error\': !isValid}"  class="minput__label">' +
    '<span>{{name}}<input v-if="!list && !readonly" :title="internalValue" @change="validate" v-model="internalValue" class="minput__input"/>' +
    '<div v-if="list && !autocomplete" class="minput__input">{{list[internalValue]}}</div>' +
    '<input v-if="list && autocomplete" :title="internalValue" v-model="internalValue" class="minput__input"/>' +
    '<div v-if="readonly && !list" class="minput__input">{{internalValue}}</div></span>' +
    '<img v-if="!list && !isValid" src="/assets/images/manager-error-icon.svg" class="minput__icon">' +
    '<div v-if="!list && !isValid && internalMessage" class="error">{{internalMessage}}</div>' +
    '<img v-if="!list && isValid && internalValue && !readonly" src="/assets/images/manager-arrow-success.svg" class="minput__icon">' +
    "</label>" +
    '<div v-if="list && !autocomplete && !readonly" class="minput__arrow"><img v-bind:class="{ \'is-open\': showContainer}"  src="/assets/images/arr5.svg"></div>' +
    '<div v-if="list && showContainer && !readonly" class="minput__container">' +
    '<div v-for="(item, index) in list" class="minput__item" @click="changeOption(index)">{{item}}</div></div></div>' +
    '<div v-else class="minput minput__stacked">' +
    '<div v-if="!list" class="minput__checkbox-label" :class="{\'centered\': centered}" @click="check"><div v-bind:class="{ \'checked\': internalValue == checkbox}" class="minput__checkbox"></div><span>{{name}}</span></div>' +
    '<div v-else class="minput__group">{{name}}</div>' +
    '<div v-for="(item,index) in list"   @click="check(index)"  class="minput__lined">' +
    '<div v-bind:class="{ \'checked\': internalValue.includes(index)}" class="minput__checkbox multiple"></div><div class="minput__checkbox-label multiple">{{item}}</div>' +
    "</div>" +
    "</div>",
}
